import React from 'react'
import PlanEntriesList from '../planEntryList/PlanEntriesList'
import AloIcon from '../../../assets/codicons/a'
import PrivateContent from '../PrivateContent'
import {
  fetchPlaylistEntries,
  setDisplayedPlaylistEntriesOrder,
  featurePlaylist,
  unfeaturePlaylist,
  updatePlaylist,
  clearPlaylistEntries
} from '../../redux/actions/playlists'
import {
  sortPlaylistEntries,
  deletePlaylistEntry
} from '../../redux/actions/playlistEntries'
import { clearPlanEntries } from '../../redux/actions/planEntries'
import {
  followPlaylist,
  unfollowPlaylist
} from '../../redux/actions/playlistFollowers'
import { displayedPlaylistEntries } from '../../redux/selectors/playlists'
import { connect } from 'react-redux'
import PlaylistHeader from './PlaylistHeader'
import './PlaylistDisplay.scss'
import PropTypes from 'prop-types'

class PlaylistDisplay extends React.Component {
  constructor (props) {
    super(props)

    this.reorderPlanEntries = this.reorderPlanEntries.bind(this)
    this.handleOnPlanEntrySort = this.handleOnPlanEntrySort.bind(this)
    this.deleteEntryFromPlaylist = this.deleteEntryFromPlaylist.bind(this)
    this.deletePlaylist = this.deletePlaylist.bind(this)
    this.handleOnTransitionEnd = this.handleOnTransitionEnd.bind(this)
    this.toggleFeatured = this.toggleFeatured.bind(this)
    this.handlePlaylistUpdate = this.handlePlaylistUpdate.bind(this)
    this.toggleFollowPlaylist = this.toggleFollowPlaylist.bind(this)

    this.state = {
      deleting: false
    }
  }

  componentDidMount () {
    const playlist = this.props.playlist
    this.props.clearPlanEntries(playlist)
    this.props.fetchPlaylistEntries(playlist)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.playlist.uuid !== this.props.playlist.uuid) {
      const playlist = this.props.playlist
      this.props.clearPlaylistEntries()
      this.props.clearPlanEntries(playlist)
      this.props.fetchPlaylistEntries(playlist)
    }
  }

  toggleFeatured () {
    const playlist = this.props.playlist
    if (playlist.featured) {
      return this.props.unfeaturePlaylist(playlist)
    } else {
      return this.props.featurePlaylist(playlist)
    }
  }

  deletePlaylist () {
    this.props.playlist.destroy().then(() => {
      this.setState({ deleting: true })
    })
  }

  handleOnTransitionEnd (e) {
    if (
      e.target === e.currentTarget &&
      e.propertyName === 'opacity' &&
      this.props.onDeleted
    ) {
      this.props.onDeleted(this.props.playlist.uuid)
      this.setState({ deleting: false })
    }
  }

  deleteEntryFromPlaylist (entryId) {
    this.props.deleteEntry(entryId)
  }

  handleOnPlanEntrySort (sortedEntryIds, e) {
    this.props.sortPlaylistEntries(sortedEntryIds, e)
  }

  reorderPlanEntries(direction, field) {
    if (field === 'coach') return
    this.props.setDisplayedPlaylistEntriesOrder({
      field,
      direction
    })

    const playlist = this.props.playlist
    this.props.clearPlaylistEntries()
    this.props.clearPlanEntries(playlist)
    this.props.fetchPlaylistEntries(playlist)
  }

  handlePlaylistUpdate (newPlaylistParams, callback) {
    this.props.updatePlaylist(this.props.playlist, newPlaylistParams, callback)
  }

  toggleFollowPlaylist () {
    const playlist = this.props.playlist

    if (playlist.following) {
      this.props.unfollowPlaylist(playlist)
    } else {
      this.props.followPlaylist(playlist)
    }
  }

  renderPlaylistContent () {
    const {
      playlist,
      arePlanEntriesLoading,
      orderBy,
      playlistPlanEntries,
      userIsAdmin,
      userIsAuthor,
      signedIn,
      includePlaylistAddedDates,
      initialPlaylistEntryLoad
    } = this.props

    if (playlist && !playlist.userCanView) {
      return <PrivateContent caption='This playlist is private' grey />
    } else if (playlist && playlist.entryCount === 0) {
      return (
        <div className='no-results empty-state' style={{ margin: '0 auto' }}>
          <AloIcon />
          <div>
            <h3 className='empty-header'>This playlist is empty</h3>
            <a className='see-more' href='/class-finder'>
              Explore Our Library
            </a>
          </div>
        </div>
      )
    } else {
      return (
        <PlanEntriesList
          locked={!signedIn}
          entries={playlistPlanEntries}
          initialLoad={initialPlaylistEntryLoad}
          isLoading={arePlanEntriesLoading}
          onReorder={this.reorderPlanEntries}
          totalPlanEntries={playlist.entryCount}
          favoritable={false}
          featurable={userIsAdmin}
          sortable={userIsAuthor}
          onPlanEntriesSorted={this.handleOnPlanEntrySort}
          orderBy={orderBy}
          onDeleted={this.deleteEntryFromPlaylist}
          removable={userIsAuthor}
          onFetchMoreEntries={() => {
            this.props.fetchPlaylistEntries(this.props.playlist)
          }}
          includeDates={includePlaylistAddedDates}
          entryLinkSuffix={`?type=playlist&uuid=${playlist.uuid}`}
        />
      )
    }
  }

  render () {
    const {
      playlistPlanEntries,
      playlist,
      signedIn,
      userIsAuthor,
      userIsAdmin,
      onDuplicated,
      userLoaded
    } = this.props

    let className = 'PlaylistDisplay'
    if (this.state.deleting) className += ' PlaylistDisplay--deleting'

    let playlistDisplayClass = 'PlaylistDisplay__header'
    if (!userLoaded) playlistDisplayClass += ' PlaylistDisplay--loading'

    return (
      <div className={className} onTransitionEnd={this.handleOnTransitionEnd}>
        <div className={playlistDisplayClass}>
          <PlaylistHeader
            playlist={playlist}
            userIsAuthor={userIsAuthor}
            signedIn={signedIn}
            planEntries={playlistPlanEntries}
            userIsAdmin={userIsAdmin}
            onDuplicated={onDuplicated}
            onPlaylistDelete={this.deletePlaylist}
            toggleFeatured={this.toggleFeatured}
            onPlaylistUpdate={this.handlePlaylistUpdate}
            toggleFollowing={this.toggleFollowPlaylist}
            deleting={this.state.deleting}
          />
        </div>
        {this.renderPlaylistContent()}
      </div>
    )
  }
}

PlaylistDisplay.propTypes = {
  arePlanEntriesLoading: PropTypes.bool,
  playlistPlanEntries: PropTypes.array,
  fetchPlaylistEntries: PropTypes.func,
  setDisplayedPlaylistEntriesOrder: PropTypes.func,
  playlist: PropTypes.object,
  orderBy: PropTypes.string,
  deleteEntry: PropTypes.func,
  onDeleted: PropTypes.func,
  featurePlaylist: PropTypes.func,
  unfeaturePlaylist: PropTypes.func,
  signedIn: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  includePlaylistAddedDates: PropTypes.bool,
  onDuplicated: PropTypes.func,
  sortPlaylistEntries: PropTypes.func,
  userLoaded: PropTypes.bool,
  initialPlaylistEntryLoad: PropTypes.bool,
  updatePlaylist: PropTypes.func,
  followPlaylist: PropTypes.func,
  unfollowPlaylist: PropTypes.func,
  clearPlanEntries: PropTypes.func,
  clearPlaylistEntries: PropTypes.func
}

const mapStateToProps = state => {
  return {
    arePlanEntriesLoading: state.ui.playlists.loadingEntries,
    playlistPlanEntries: displayedPlaylistEntries(state),
    orderBy: state.ui.playlists.entriesOrder
      ? state.ui.playlists.entriesOrder.field
      : null,
    initialPlaylistEntryLoad: state.ui.playlists.initialPlaylistEntryLoad,
    userLoaded: state.users.loaded
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchPlaylistEntries: (playlist, reloadAll) => {
      if (playlist.entryCount > 0) {
        dispatch(fetchPlaylistEntries(playlist, reloadAll))
      }
    },
    setDisplayedPlaylistEntriesOrder: orderObj => {
      dispatch(setDisplayedPlaylistEntriesOrder(orderObj))
    },
    clearPlanEntries: playlist => {
      dispatch(
        clearPlanEntries(planEntry =>
          planEntry.playlistIds.includes(playlist.uuid)
        )
      )
    },
    sortPlaylistEntries: (sortedEntryIds, e) => {
      dispatch(sortPlaylistEntries(ownProps.playlist, sortedEntryIds, e))
    },
    deleteEntry: entryId => {
      dispatch(deletePlaylistEntry(entryId))
    },
    featurePlaylist: playlist => {
      return dispatch(featurePlaylist(playlist))
    },
    followPlaylist: playlist => {
      return dispatch(followPlaylist(playlist))
    },
    unfeaturePlaylist: playlist => {
      return dispatch(unfeaturePlaylist(playlist))
    },
    unfollowPlaylist: playlist => {
      return dispatch(unfollowPlaylist(playlist))
    },
    updatePlaylist: (playlist, params, callback) => {
      return dispatch(updatePlaylist(playlist, params, callback))
    },
    clearPlaylistEntries: () => {
      return dispatch(clearPlaylistEntries())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistDisplay)
